import { useMutation } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

interface GenerateHintRequest {
  practiceAnswerId: string;
}

interface GenerateHintResponse {
  hint: string;
  cached: boolean;
}

const useGenerateHint = () => {
  return useMutation({
    mutationFn: async ({ practiceAnswerId }: GenerateHintRequest): Promise<GenerateHintResponse> => {
      const { data: { session } } = await supabaseClient.auth.getSession();

      if (!session) {
        throw new Error('Not authenticated');
      }

      const response = await supabaseClient.functions.invoke('generate-hint', {
        body: {
          practice_answer_id: practiceAnswerId,
        },
      });

      if (response.error) {
        throw new Error(response.error.message || 'Failed to generate hint');
      }

      return response.data;
    },
  });
};

export default useGenerateHint;
